/* eslint-disable i18next/no-literal-string */

export const Theme = {
  Cmc: 'cmc',
  CmcInvestSingapore: 'cmcinvestsingapore'
} as const;
